"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../../common");
const FullScreenBtn = ({ className, video, autoPlay = true, handlerFullScreen, handlerExitFullScreen, }) => {
    const [isFullscreen, setIsFullscreen] = (0, react_1.useState)(false);
    const [errorOpen, setErrorOpen] = (0, react_1.useState)(false);
    const enterFullscreen = () => {
        try {
            // 전체 화면 요청
            if (handlerFullScreen) {
                handlerFullScreen();
            }
        }
        catch (error) {
            const streamingContainer = document.getElementById('streaming-container');
            if (streamingContainer) {
                streamingContainer.classList.remove('show');
            }
            setErrorOpen(true);
        }
    };
    const exitFullscreen = () => {
        if (errorOpen) {
            const streamingContainer = document.getElementById('streaming-container');
            if (streamingContainer) {
                streamingContainer.classList.add('show');
            }
            return;
        }
        try {
            if (handlerExitFullScreen) {
                handlerExitFullScreen();
            }
        }
        catch (error) {
            const streamingContainer = document.getElementById('streaming-container');
            if (streamingContainer) {
                streamingContainer.classList.add('show');
            }
        }
    };
    const toggleFullscreen = () => {
        if (isFullscreen) {
            exitFullscreen();
        }
        else {
            enterFullscreen();
        }
        setIsFullscreen(!isFullscreen);
    };
    (0, react_1.useEffect)(() => {
        const handleFullscreenChange = () => {
            // @ts-ignore
            if (!document.fullscreenElement || !document.webkitFullscreenElement) {
                setIsFullscreen(false);
            }
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
        };
    }, []);
    return (react_1.default.createElement(common_1.Button, { id: "fullscreenBtn", className: className, onClick: toggleFullscreen, option: {
            buttonBeforeIcon: {
                show: true,
                name: isFullscreen ? 'fullScreen_on' : 'fullScreen_off',
                size: 25,
                color: '#fff',
                stroke: '#fff',
                className: 'handlerIcon',
            },
        } })
    // <button id="fullscreenBtn" className={` ${className}`} onClick={toggleFullscreen}>
    // 	{isFullscreen ? '전체보기 종료' : '전체보기'}
    // </button>
    );
};
exports.default = FullScreenBtn;
